export const required = 'Field is required';

export const emailPattern = () => ({
  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/i,
  message: 'Invalid email address',
});

export const phonePattern = () => ({
  value: /^\(\d{3}\)\s\d{3}-\d{4}$/,
  message: 'Invalid phone number format',
});
